import React from "react"
import "./style.css"
import '../../store/reducers'
import { Outlet } from "react-router-dom"

const HelpSection = (props) => {
	return (<>
		<Outlet />
	</>)
}
export default HelpSection
